import React, { useState } from 'react';
import { Tabs } from 'antd';
import UploadCelebrateEcard from '../Pages/UploadEcard'
import UploadCoreEcards from  '../Pages/UploadCoreEcards'
const EcardsPage: React.FC = () => {
  const [activeKey, setActiveKey] = useState('1');

  const onTabChange = (key: string) => {
    setActiveKey(key);
  };

  return (
    <Tabs activeKey={activeKey} onChange={onTabChange}>
      <Tabs.TabPane tab="Upload Core Values Ecards" key="1">
        <UploadCoreEcards />      
      </Tabs.TabPane>
      <Tabs.TabPane tab="Upload Celebrate Ecards" key="2">
        <UploadCelebrateEcard />      
      </Tabs.TabPane>
    </Tabs>
  );
};

export default EcardsPage;